import { useState, useEffect } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/FmsTypes";
import { UserTypeEnum } from "@/types/FmsEnums";
import { useGlobalModel } from "@/model/globalModel";
import { getProdBaseRequestUrl } from "@/utils/constants";
import { message } from 'antd';
import { convertRes2Blob, convertRes2Blob2WithFileName } from "@/utils/exportFile";
import { transPgToPagination } from "@/views/base/app/appModel";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { invoiceManageService } from "@/views/invoice/manage/InvoiceManageService";
import { InvoiceBillSearch, InvoiceBill, InvoiceSummary } from "@/views/invoice/manage/InvoiceManageTypes";
import { dictService } from "@/views/base/dict/dictService";
import { useDetailModel } from "../detailModel";


type labelsType = {
    [proppName: string]: string;
}

export const billDataModel = createModel(function () {
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    const { user: { shopCode }, beDs, setLoadingInfo } = useGlobalModel();
    const { customerCode, customer } = useDetailModel();

    //查询条件
    const [searchParam, setSearchParam] = useState<InvoiceBillSearch>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<InvoiceBill[]>([]);
    const [summaryData, setSummaryData] = useState<InvoiceSummary>();
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedData, setSelectedData] = useState<InvoiceBill[]>([]);
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //支付类型解析
    const [payMethodLabels, setPayMethodLabels] = useState<labelsType>({});

    //按钮可用
    const [uploadDisable, setUploadDisable] = useState<boolean>(true);
    const [nobillDisable, setNobillDisable] = useState<boolean>(true);
    const [applyDisable, setApplyDisable] = useState<boolean>(true);

    const loadPayMethodLabel = () => {
        dictService.dictItemDs("settle-type").then(ds => {
            let obj: labelsType = {}
            ds.forEach(item => {
                obj[item.value] = item.label
            })
            setPayMethodLabels(obj)
        })
    }

    const onSearch = () => {
        loadData({ pageNum: 1 }, { ...searchParam })
        setSelectedRowKeys([]);
        setSelectedData([])
    }

    const onReset = () => {
        setSearchParam({});
        loadData(initPgCfg, {});
        setSelectedRowKeys([]);
        setSelectedData([])
    }

    const updateSearchParam = (updateParam: InvoiceBillSearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    const loadData = async (page: ISearchPage = initPgCfg, searchValue: InvoiceBillSearch = searchParam) => {
        const searchParams = {
            ...defaultMdCmParam,
            ...searchValue,
            shopCode,
            partnerCode: customerCode,
            partnerTypeCode: UserTypeEnum.CUSTOMER,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }

        let { retData } = await invoiceManageService.invoiceBillPage(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);

        let { retData: summaryData } = await invoiceManageService.invoiceBillSummary(searchParams);
        setSummaryData(summaryData);
    }

    //客户发票账单导出
    const invoiceBillExport = async () => {
        setLoadingInfo({ loadingVisible: true, txt: '导出中,请稍等...' });
        const searchParams = {
            ...searchParam,
            shopCode,
            partnerCode: customerCode,
            partnerTypeCode: UserTypeEnum.CUSTOMER
        }
        let result = await invoiceManageService.invoiceBillExport(searchParams);
        convertRes2Blob(result);
        setLoadingInfo({ loadingVisible: false, txt: '' });
    }

    //客户发票账单附件导出
    const invoiceBillExportAttach = async () => {
        setLoadingInfo({ loadingVisible: true, txt: '导出中,请稍等...' });
        const searchParams = {
            ...searchParam,
            shopCode,
            partnerCode: customerCode,
            partnerTypeCode: UserTypeEnum.CUSTOMER
        }
        let ret = await invoiceManageService.invoiceMd5(searchParams);
        let md5List = Array.from(Object.values(ret), x => x);
        if (md5List.length > 0) {
            console.log(md5List)
            let fileServerUrl = getProdBaseRequestUrl() + "/fsrv/download_zip";

            let fileName = "客户账单附件.zip";
            let file = await invoiceManageService.invoiceMd5Export(fileServerUrl, { "zipName": fileName, "files": md5List });
            convertRes2Blob2WithFileName(file, fileName);
        }
        else {
            message.error("没有附件信息")
        }
        setLoadingInfo({ loadingVisible: false, txt: '' });
    }

    //上传发票、无票收入、无票申请开票 能否点击切换
    const buttonDisableCheck = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            let flag_upload = 0;
            let flag_nobill = 0;
            let flag_apply = 0;
            selectedData.forEach(data => {
                if (data.invoiceStatus == 1) {
                    flag_upload++;
                }
                if (data.invoiceNum != null) {
                    flag_upload++;
                    flag_nobill++;
                    flag_apply++;
                }
            });

            flag_upload == 0 ? setUploadDisable(false) : setUploadDisable(true);
            flag_nobill == 0 ? setNobillDisable(false) : setNobillDisable(true);
            flag_apply == 0 ? setApplyDisable(false) : setNobillDisable(true);
        }
        else {
            setUploadDisable(true);
            setNobillDisable(true);
            setApplyDisable(true);
        }
    }


    return {
        /***field***/
        initPgCfg,
        searchParam,
        dataSource,
        pgCfg,
        summaryData,
        payMethodLabels,
        beDs,
        selectedRowKeys,
        selectedData,
        uploadDisable,
        nobillDisable,
        applyDisable,
        /***method***/
        setDataSource,
        updateSearchParam,
        loadData,
        onSearch,
        onReset,
        invoiceBillExport,
        invoiceBillExportAttach,
        setSelectedRowKeys,
        setSelectedData,
        setUploadDisable,
        setNobillDisable,
        setApplyDisable,
        buttonDisableCheck,
        loadPayMethodLabel
    }
});